import React, { useState } from 'react';
import styles from './PublicTrustSnapshotCard.module.scss';

type TrustAvatarProps = {
  src: string | null | undefined;
  alt: string;
  className?: string;
};

const TrustAvatar: React.FC<TrustAvatarProps> = ({ src, alt, className }) => {
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !src || failed;

  if (showPlaceholder) {
    return <span className={`${styles.avatarPlaceholder} ${className ?? ''}`} aria-hidden />;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
};

export default TrustAvatar;
